import { useRef } from "react";
import { useSelector } from "react-redux";

import shuffle from "seneca-common/utils/functions/random/shuffle";
import { getRegion } from "seneca-common/features/user/state";
import { DEFAULT_REGION } from "common/static/regions";

export function useFailGif() {
  const userRegion = useSelector(getRegion) || DEFAULT_REGION;
  const regionGifs = (gifs as any)[userRegion] || gifsWithoutCopy;

  const ref = useRef(shuffle(regionGifs)[0]);

  return ref.current;
}

const gifsWithoutCopy = [
  "https://media.giphy.com/media/pKoLm8ZOPgzbq/giphy.mp4",
  "https://media.giphy.com/media/Qg3INeWFlyRVk4gT1K/giphy.mp4"
];

const gifs = {
  GB: [
    "https://media.giphy.com/media/kDqvtJtxMTFRcqR2r4/giphy.mp4",
    "https://media.giphy.com/media/3o7aD3CCHZcZ2bUNCo/giphy.mp4",
    "https://media.giphy.com/media/xT5LMSQkGkflW3kB9K/giphy.mp4",
    "https://media.giphy.com/media/l0Ex9jSNk3bLmAhJS/giphy.mp4",
    ...gifsWithoutCopy
  ],
  BR: [
    "https://media.giphy.com/media/tisE1AyTZVVqE/giphy.mp4",
    "https://media.giphy.com/media/3fDONRErOAxTa/giphy.mp4",
    ...gifsWithoutCopy
  ]
};
